export { default } from './CheckInIntroWithImageQuizStep';
